import React, {
	createContext,
	type ReactNode,
	useCallback,
	useContext,
	useMemo,
	useState,
} from 'react';

type OrgContextProvider = [string, (id: string) => void];

export const OrgContext = createContext<OrgContextProvider>(['', () => {}]);

const OrgProvider = ({ children }: { children: ReactNode }) => {
	const [orgId, setOrgId] = useState<string>('');

	const setOrgIdCallback = useCallback(
		(id: string) => {
			setOrgId(id);
		},
		[setOrgId],
	);

	const orgProviderState = useMemo<OrgContextProvider>(
		() => [orgId, setOrgIdCallback],
		[orgId, setOrgIdCallback],
	);

	return <OrgContext.Provider value={orgProviderState}>{children}</OrgContext.Provider>;
};

export const useOrgProvider = () => useContext(OrgContext);

export default OrgProvider;
